module.exports = __webpack_public_path__ + "img/card-i6.4dfd1654.png";